import { Palette } from 'config';
import styled from 'styled-components';

export const Item = styled.div`
  display: flex;
  flex-direction: row;
  min-width: 165px;
  height: 32px;
  background: #ffffff;
  border: 1px solid ${Palette.PrimaryGray._200};
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  margin-bottom: 1px;
  font-weight: 500;
  font-size: 12px;
  line-height: 32px;
  padding-left: 8px;
`;

export const Label = styled.p`
  color: ${({ exclude }) => (exclude ? `${Palette.Red._600}` : `${Palette.Teal._600}`)};
`;

export const DeleteBtn = styled.div`
  margin-left: auto;
  align-self: center;
`;
